import React from 'react';
import styles from './share-box.module.scss';
import { appURL } from 'shared/constants/APIconstants';
import { UploadOutlined, CopyOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';
import { getLang } from 'shared/store/selectors/lang.selector';
import analyticsService from '../../../helpers/analytics.service';
import { EVENTS } from 'shared/constants/analytics';
import { CopyToClipboard } from 'src/components/common/copy-to-clipboard';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLaptopMedical } from '@fortawesome/pro-regular-svg-icons';
import { useShare } from './share.context';
import { Dropdown } from 'src/components/design-system';
import { Tooltip } from 'src/components/core';

const ShareBoxComponent = React.memo(function ShareBoxComponent({
  path,
  iconClassName = styles.icon,
  id,
  title,
  type,
  tags,
  entityType,
  className,
}) {
  const lang = useSelector(getLang('SHARE'));
  const buttonLang = useSelector(getLang('ACTION_BUTTON_TOOLTIPS'));
  const { magicLink } = useShare();
  const [visible, setVisible] = React.useState(false);
  const [isHovered, setIsHovered] = React.useState(false);

  const RESOURCE_LINK = `${appURL.slice(0, appURL.length - 1)}${path}`;
  const magicLinkFullUrl = magicLink ? `${magicLink}&redirect_url=${RESOURCE_LINK}` : null;

  const onCopy = async link => {
    analyticsService.track(`${EVENTS.SHARE.COPY_LINK} - ${entityType}`, {
      link,
      id,
      title,
      type,
      ...tags,
      entityType,
    });
  };

  const handleMenuItemClick = e => {
    e.domEvent.stopPropagation();
    e.domEvent.preventDefault();
    // Find the copy button inside the menu item and trigger its click
    const copyButton = e.domEvent.currentTarget.querySelector('[data-copy-to-clipboard]');
    if (copyButton) {
      copyButton.click();
    }
  };

  const items = [
    {
      key: lang.COPY_LINK,
      label: (
        <CopyToClipboard text={RESOURCE_LINK} onCopy={() => onCopy(RESOURCE_LINK)}>
          <CopyOutlined className={styles.optionIcon} aria-hidden="true" />
          {lang.COPY_LINK}
        </CopyToClipboard>
      ),
      onClick: handleMenuItemClick,
    },
  ];

  if (magicLink) {
    items.push({
      key: lang.COPY_MAGIC_LINK,
      label: (
        <CopyToClipboard text={magicLinkFullUrl} onCopy={() => onCopy(magicLinkFullUrl)}>
          <FontAwesomeIcon icon={faLaptopMedical} className={styles.optionIcon} />
          {lang.COPY_MAGIC_LINK}
        </CopyToClipboard>
      ),
      onClick: handleMenuItemClick,
    });
  }

  return (
    <Tooltip title={buttonLang.SHARE_ITEM} open={isHovered && !visible}>
      <div
        onFocus={() => setIsHovered(true)}
        onBlur={() => setIsHovered(false)}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <Dropdown
          items={items}
          trigger={['click']}
          open={visible}
          onOpenChange={setVisible}
          placement="bottomLeft"
          childrenWrapperStyle={className}
          aria-label={buttonLang.SHARE_ITEM}
        >
          <UploadOutlined className={iconClassName} aria-hidden="true" />
        </Dropdown>
      </div>
    </Tooltip>
  );
});

export { ShareBoxComponent };
